const resources = {
    featuredOffers: 'Offres en vedette'
};

export default function getResource(label) {
    return resources[label];
}
